import cn from 'classnames';
import React from 'react';

import styles from './Card.module.css';

interface CardProps {
  variant?: 'white' | 'gray' | 'warning';
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Card = ({ variant, children, className, style }: CardProps) => {
  return (
    <div
      className={cn([styles.card, variant && styles[variant], className])}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
